import React, { Component } from 'react'
import { Link, Redirect } from 'react-router-dom'
import auth from '../../helpers/auth'
import axios from 'axios'
import '../../../LoginAnimation.css';
import { useNavigate } from 'react-router-dom';

/**
 * Login component
 */
class Login extends Component {

    constructor(props) {
        super(props);

        this.state = {
            require2FA: false,
            otp: '',
            email: '',
            password: '',
            remember: true,
        }
    }

    _isMounted = false

    /**
     * Hides the nav-bar on mount of the component
     */
    componentDidMount() {
        document.title = "BMS App- Login"
        this._isMounted = true
        document.getElementById('navigation-bar').style.display = "none";
        var orig = document.body.className;
        document.body.classList.add('login-page');
    }

    /**
     * Restores the nav-bar on the unmount
     */
    componentWillUnmount() {
        this._isMounted = false
        document.getElementById('navigation-bar').style.display = "flex";
        document.body.classList.remove('login-page');
    }


    /**
     * Makes the login request to the backend and handles the response prperly
     * On Successful response: stores the credentials on the auth object and redirects the user in a proper pager
     * Otherwise: error message is displayed
     * @param {object} e triggered event
     */
    onSubmit(e) {
        e.preventDefault();
        const { email, password, remember } = this.state;
        console.log("requsting: " + process.env.REACT_APP_API_URL + 'login');
        axios.post(process.env.REACT_APP_API_URL + 'login', {
            headers: {
                'Access-Control-Allow-Origin': '*',
            },
            "email": email,
            "password": password
        }).then(response => {
                this.doLogin(response, remember);
        }).catch(error => {
            if (error.response?.data?.totpIsRequired && error.response.status === 401) {
                console.log("Payload:", error.response.data); // 👈 This is the response payload
                console.log("Payload:", error.response.data.totpIsSetup === "false"); // 👈 This is the response payload
                if(error.response.data.totpIsSetup === 'false'){
                    this.props.history.push('/p3tpfas', {
                        email,
                        password
                    });
                }
                this.setState({ require2FA: true });
            } else {
                console.log(error);
                this.refs.email.value = "";
                this.refs.password.value = "";
                if (this._isMounted) {
                    this.setState({ err: true });
                    setTimeout(() => this.setState({
                        err: undefined
                    }), 3000);
                }
            }
        });

    }

    doLogin(response, remember) {
        auth.login(response, remember, () => {
            const { from } = this.props.location.state || { from: { pathname: '/dashboard' } }
            this.props.history.push(from)
        })
        if (this._isMounted) {
            this.setState({ err: false });
        }
        this.props.updateAuth(true);
    }
    submitOTP(e) {
        e.preventDefault();
        const { email, password, remember, otp } = this.state;
        console.log("requsting: " + process.env.REACT_APP_API_URL + 'verify_2fa_login');
        axios.post(process.env.REACT_APP_API_URL + 'verify_2fa_login', {
            headers: {
                'Access-Control-Allow-Origin': '*',
            },
            "email": email,
            "password": password,
            "totpCode": otp,
        }).then(response => {
            this.setState({ require2FA: true });
            this.doLogin(response, remember);
        }).catch(error => {
            console.log("Errrorrr:", error); // 👈 This is the response payload
            if (this._isMounted) {
                this.setState({ err: true });
                this.setState({
                    err: "Invalid OTP"
                });
            }
        });
    }
    /**
     * updates the typeed text in the state
     * @param {object} e triggered event
     */
    onChange(e) {
        const { name, value, type, checked } = e.target;
        type === "checkbox" ? this.setState({ [name]: checked }) : this.setState({ [name]: value })
    }

    /**
     * shows the component
     */
    render() {
        const { from } = this.props.location.state || { from: { pathname: '/dashboard' } }
        if (auth.isAuthenticated())
            return (
                <Redirect to={from} />
            )

        let error = this.state.err;
        let msg = (!error) ? 'Login Successful' : 'Wrong Credentials';
        let name = (!error) ? 'alert alert-success' : 'alert alert-danger';
        return (
            <div className="limiter">
                {!this.state.require2FA &&
                    <div className="wrapper-login">
                        <div className="logo"></div>
                        <h1>Monitoring, Reporting &amp; Administration Platform</h1>
                        <div className="container-login">
                            <div className="container-login100" >
                                <div className="wrap-login100">
                                    <div >
                                        {error !== undefined && <div className={name} role="alert">{msg}</div>}
                                    </div>
                                    <form className="login100-form validate-form" method="POST" onSubmit={this.onSubmit.bind(this)}>
                                        <span className="login100-form-title p-b-34 p-t-27">
                                            Log in
                                        </span>

                                        <div className="wrap-input100 validate-input" data-validate="Enter email">
                                            <input
                                                id="email"
                                                type="email"
                                                ref="email"
                                                className="input100"
                                                name="email"
                                                value={this.state.email}
                                                onChange={this.onChange.bind(this)}
                                                required
                                                placeholder="Email"
                                            />
                                            <span className="focus-input100" data-placeholder="&#xf207;"></span>
                                        </div>

                                        <div className="wrap-input100 validate-input" data-validate="Enter password">
                                            <input
                                                id="password"
                                                type="password"
                                                ref="password"
                                                className="input100"
                                                name="password"
                                                value={this.state.password}
                                                onChange={this.onChange.bind(this)}
                                                required
                                                placeholder="Password"
                                            />
                                            <span className="focus-input100" data-placeholder="&#xf191;"></span>
                                        </div>

                                        <div className="contact100-form-checkbox">
                                            <input
                                                type="checkbox"
                                                checked={this.state.remember}
                                                className="input-checkbox100"
                                                id="ckb1"
                                                name="remember"
                                                onChange={this.onChange.bind(this)}
                                            />
                                            <label className="label-checkbox100" htmlFor="ckb1">
                                                Remember me
                                            </label>
                                        </div>

                                        <div className="container-login100-form-btn">
                                            <button type="submit" className="login100-form-btn" style={{ width: "312px" }}>
                                                Login
                                            </button>
                                        </div>

                                        <div className="text-center p-t-90">
                                            <Link to="forgotpassword" className="txt1">
                                                Forgot Password?
                                            </Link>
                                        </div>
                                        <div className="text-center p-t-90">
                                            <a className="txt1" href="https://digisec.gr/">
                                                For more info visit our website digisec.gr
                                            </a>
                                        </div>

                                    </form>

                                </div>

                            </div>
                            <div className="bird-container bird-container--one lock">
                                <div className="bird bird--one "></div>
                            </div>
                            <div className="bird-container bird-container--two lock">
                                <div className="bird bird--two "></div>
                            </div>
                            <div className="bird-container bird-container--three lock">
                                <div className="bird bird--three "></div>
                            </div>
                            <div className="bird-container bird-container--four lock">
                                <div className="bird bird--four "></div>
                            </div>
                        </div>
                        <h2>Bird Monitoring<br />
                            System</h2>

                        <div className="bottom-login">

                            {/*<!– wind turbine start ––> */}
                            <div className="wind-turbine">
                                <div className="rotor">
                                    <div className="blade blade1"></div>
                                    <div className="blade blade2"></div>
                                    <div className="blade blade3"></div>
                                </div>
                                <div className="pulse"></div>
                                <div className="pole"></div>
                            </div>
                            {/*<! –– wind turbine ends ––>*/}

                        </div>
                    </div>}
                {this.state.require2FA &&
                    <div className="wrapper-login">
                        <div className="logo"></div>
                        <div className="container-login">

                            <div style={{
                                display: 'flex',
                                paddingTop: '14%',
                                flexDirection: 'column',
                                gap: '14%',
                                height: '100%',
                                alignItems: 'center'
                            }} >
                                <div style={{ maxWidth: '700px', textAlign: 'center' }}>
                                    <h3>Open your two-factor authentication app</h3>
                                    <br></br>
                                    <h4>Enter the 6-digit code for this account from the two-factor authentication app you set up earlier (such as Google Authenticator or Microsoft Authenticator).</h4>
                                </div>

                                <div className="wrap-login100">
                                    <div >
                                        {error !== undefined && <div className={name} role="alert">{this.state.err}</div>}
                                    </div>
                                    <form className="login100-form validate-form" onSubmit={this.submitOTP.bind(this)}>
                                        <div className="wrap-input100" data-validate="Enter otp">
                                            <input
                                                id="otp"
                                                type="text"
                                                ref="otp"
                                                className="input100"
                                                name="otp"
                                                minLength="6"
                                                maxLength="6"
                                                value={this.state.otp}
                                                onChange={this.onChange.bind(this)}
                                                required
                                                placeholder="Type your otp here"
                                            />
                                            <span className="focus-input100" data-placeholder="&#xf191;"></span>
                                        </div>

                                        <div className="container-login100-form-btn">
                                            <button type="submit" className="login100-form-btn" style={{ width: "312px" }}>
                                                Login
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>}
            </div>

        );
    }
}

export default Login;

